export const ONBOARDING_WRAPPER_LABELS = {
    GREETING: 'Hola 👋🏻 bienvenido a tu Administrador de pagos automáticos.',
    BTNCONFIRM: 'Continuar',
    PARAGRAPH: 'Aquí puedes gestionarlos de forma simple en un solo lugar.'
}
  